import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { SessionTimeoutService } from '../services/session-timeout.service';
import { PermissionService } from '../services/permission.service'
import { OAuthService } from '../../shared/services/authorization/oauth.service';
import { TokenResponse } from '@openid/appauth';

import { Observable, of, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { MaintenanceGuard } from './maintenance.guard';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private oauthService: OAuthService,
    private sessionTimeoutService: SessionTimeoutService,
    private permissionService: PermissionService,
    private maintenanceGuard: MaintenanceGuard) { }

  public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    if (this.maintenanceGuard.canActivate(next, state) === false) {
      return of(false);
    }

    return this.oauthService.tokenResponse().pipe(map((tokenResponse: TokenResponse) => {

      const authenticated = tokenResponse !== null && tokenResponse.isValid(0);

      if (!authenticated) {
        this.sessionTimeoutService.stopTimers();
        this.oauthService.emptySessionStorage();
        this.oauthService.authorize(state.url);
        return authenticated;
      }

      this.sessionTimeoutService.resetTimers();

      // at this point we are authenticated through ping,
      // so we need to check if we have their permissions loaded
      this.permissionService.checkPermissions();

      return authenticated;
    }));
  }

}